import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from '@/components/action-sheet';
import { EmployeeRestaurant } from '@/contexts/user-context';
import { InboundListItem } from './types';
import { useBaseItemQueryVariables } from '@/hooks/use-item-query-variables';
import { useToasts } from '@/contexts/toast-context';
import { useUpdateInboundQuantity } from './queries';

interface Props {
  activeRestaurant: EmployeeRestaurant;
  itemToRemove: InboundListItem;
  onClose: (itemRemoved: boolean) => void;
}

export const RemoveListItemActionSheet: React.FC<Props> = ({
  activeRestaurant,
  itemToRemove,
  onClose,
}) => {
  const baseItemQueryVariables = useBaseItemQueryVariables();
  const [updateQuantityMutation, { loading }] = useUpdateInboundQuantity();
  const { showErrorToast } = useToasts();

  return (
    <ActionSheet
      actions={[i18n.t('back'), i18n.t('remove')]}
      dangerIndices={[1]}
      isVisible
      loadingActionIndex={loading ? 1 : undefined}
      message={i18n.t('remove_inbound_item.message')}
      onAction={async (_, index) => {
        if (index === 0) {
          onClose(false);
          return;
        }
        const smartOrderInputUUID =
          itemToRemove.metadata?.inputWithResult.result?.uuid;

        // if there is no saved search_input, just remove the local item
        if (!smartOrderInputUUID) {
          onClose(true);
          return;
        }

        try {
          await updateQuantityMutation({
            variables: {
              ...baseItemQueryVariables,
              quantity: 0,
              restaurantUUID: activeRestaurant.uuid,
              skipGroupMemberships: true,
              smartOrderInputUUID,
            },
          });
          onClose(true);
        } catch {
          showErrorToast();
        }
      }}
      onClose={() => onClose(false)}
      primaryIndices={[0]}
      title={i18n.t('remove_inbound_item.title', {
        searchTerm: itemToRemove?.title,
      })}
    />
  );
};
